export enum FractionQuarterOfYearValueEnum {
  Q1 = 'q1',
  Q2 = 'q2',
  Q3 = 'q3',
  Q4 = 'q4'
}
